import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appendTopControlsLabel]'
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class AppendTopControlsLabel {
  template = inject<TemplateRef<unknown>>(TemplateRef);
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[prependTopControlsLabel]'
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class PrependTopControlsLabel {
  template = inject<TemplateRef<unknown>>(TemplateRef);
}
